var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_47_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EE6666",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.19048,
    y: 0.190476,
    width: 31.619,
    height: 31.619,
    rx: 15.8095,
    stroke: "black",
    strokeWidth: 0.380952,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_47_5",
    maskUnits: "userSpaceOnUse",
    x: 8.42859,
    y: 6.28564,
    width: 19,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8.42859,
    y: 6.28564,
    width: 19,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4563 24.2856L21.1865 20.1169H14.8016L13.5318 24.2856H9.53075L15.712 6.70023H20.2521L26.4573 24.2856H22.4563ZM20.3 17.0023C19.1261 13.2249 18.4632 11.0886 18.3115 10.5935C18.1677 10.0983 18.0639 9.707 18 9.4195C17.7365 10.4417 16.9818 12.9693 15.736 17.0023H20.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.4563 24.2856L21.1865 20.1169H14.8016L13.5318 24.2856H9.53075L15.712 6.70023H20.2521L26.4573 24.2856H22.4563ZM20.3 17.0023C19.1261 13.2249 18.4632 11.0886 18.3115 10.5935C18.1677 10.0983 18.0639 9.707 18 9.4195C17.7365 10.4417 16.9818 12.9693 15.736 17.0023H20.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4563 24.2856L22.0918 24.3966L22.1741 24.6666H22.4563V24.2856ZM21.1865 20.1169L21.5509 20.0059L21.4687 19.7359H21.1865V20.1169ZM14.8016 20.1169V19.7359H14.5194L14.4372 20.0059L14.8016 20.1169ZM13.5318 24.2856V24.6666H13.814L13.8962 24.3966L13.5318 24.2856ZM9.53075 24.2856L9.17135 24.1593L8.99304 24.6666H9.53075V24.2856ZM15.712 6.70023V6.31927H15.4421L15.3526 6.5739L15.712 6.70023ZM20.2521 6.70023L20.6113 6.57346L20.5217 6.31927H20.2521V6.70023ZM26.4573 24.2856V24.6666H26.9957L26.8166 24.1589L26.4573 24.2856ZM20.3 17.0023V17.3833H20.8173L20.6638 16.8893L20.3 17.0023ZM18.3115 10.5935L17.9456 10.6997L17.9472 10.7051L18.3115 10.5935ZM18 9.4195L18.3719 9.33686L17.6311 9.32439L18 9.4195ZM15.736 17.0023L15.372 16.8899L15.2196 17.3833H15.736V17.0023ZM22.8207 24.1746L21.5509 20.0059L20.8221 20.2279L22.0918 24.3966L22.8207 24.1746ZM21.1865 19.7359H14.8016V20.4978H21.1865V19.7359ZM14.4372 20.0059L13.1674 24.1746L13.8962 24.3966L15.166 20.2279L14.4372 20.0059ZM13.5318 23.9047H9.53075V24.6666H13.5318V23.9047ZM9.89014 24.412L16.0714 6.82655L15.3526 6.5739L9.17135 24.1593L9.89014 24.412ZM15.712 7.08118H20.2521V6.31927H15.712V7.08118ZM19.8929 6.82699L26.0981 24.4124L26.8166 24.1589L20.6113 6.57346L19.8929 6.82699ZM26.4573 23.9047H22.4563V24.6666H26.4573V23.9047ZM20.6638 16.8893C19.4897 13.1113 18.8272 10.976 18.6757 10.4818L17.9472 10.7051C18.0993 11.2011 18.7624 13.3385 19.9362 17.1154L20.6638 16.8893ZM18.6773 10.4872C18.5344 9.99506 18.4332 9.6127 18.3719 9.33686L17.6281 9.50214C17.6946 9.80129 17.801 10.2016 17.9456 10.6997L18.6773 10.4872ZM17.6311 9.32439C17.3703 10.3359 16.6188 12.8537 15.372 16.8899L16.0999 17.1147C17.3448 13.085 18.1026 10.5475 18.3689 9.5146L17.6311 9.32439ZM15.736 17.3833H20.3V16.6214H15.736V17.3833Z",
    fill: "black",
    mask: "url(#path-3-outside-1_47_5)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_47_5",
    x: 0.47619,
    y: 0,
    width: 35.0476,
    height: 35.0476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.52381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.761905
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47_5",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2);
export default __webpack_public_path__ + "static/media/A2.367ea67e1d13a510676c3ae0998c8881.svg";
export { ForwardRef as ReactComponent };